// extracted by mini-css-extract-plugin
module.exports = {"search":"Header_search__Dz8oC","searchTerm":"Header_searchTerm__1_iaV","searchButton":"Header_searchButton__hyvru","signIn":"Header_signIn__hcZ3m","signUp":"Header_signUp__pe80_"};